module.exports = __webpack_public_path__ + "img/5-4.bfe9bd98.png";